import { createContext, useContext } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const MessageContext = createContext();

export const ToastTypes = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  INFO: 'INFO',
  LOADING: 'LOADING',
};

const MessageProvider = ({ children }) => {
  const shouldBlockWebsiteToasts = () => {
    if (typeof window === 'undefined') return false;
    const pathname = window.location?.pathname || '';
    // Keep toasts enabled for panel routes and checkout routes, disable for other website routes.
    return !/^\/(admin|seller|affiliate|checkout)(\/|$)/.test(pathname);
  };

  const showToast = (toastMsg, type, options = {}) => {
    // hide toast for website routes uncomment when we want to live website
    // if (shouldBlockWebsiteToasts()) {
    //   return options.toastId || null;
    // }

    switch (type) {
      case ToastTypes.SUCCESS: {
        return options.toastId
          ? toast.update(options.toastId, { render: toastMsg, type: 'success', isLoading: false, autoClose: 1000 })
          : toast.success(toastMsg);
      }
      case ToastTypes.ERROR: {
        const userType = localStorage.getItem('USER_TYPE');
        if (userType === 'admin') {
          return options.toastId
            ? toast.update(options.toastId, { render: toastMsg, type: 'error', isLoading: false, autoClose: 1000 })
            : toast.error(toastMsg);
        }
        return null;
      }
      case ToastTypes.WARNING: {
        return toast.warning(toastMsg, { autoClose: 1000 });
      }
      case ToastTypes.INFO: {
        return toast.info(toastMsg, { autoClose: 1000 });
      }
      case ToastTypes.LOADING: {
        return toast.loading(toastMsg, { autoClose: 1000 });
      }
      default: {
        toast(toastMsg, { autoClose: 1000 });
      }
    }
  };

  return (
    <MessageContext.Provider value={{ showToast }}>
      {children}
      <ToastContainer />
    </MessageContext.Provider>
  );
};

export const useMessage = () => useContext(MessageContext);

// Expose a simple global dispatcher for places not wrapped with the hook
if (typeof window !== 'undefined') {
  window.dispatchToast = ({ type, message }) => {
    try {
      const pathname = window.location?.pathname || '';
      if (!/^\/(admin|seller|affiliate|checkout)(\/|$)/.test(pathname)) {
        return null;
      }
      switch (type) {
        case 'success':
          toast.success(message, { autoClose: 15000 });
          break;
        case 'error':
          if (localStorage.getItem('USER_TYPE') === 'admin') toast.error(message, { autoClose: 15000 });
          break;
        case 'warning':
          toast.warning(message, { autoClose: 15000 });
          break;
        case 'info':
          toast.info(message, { autoClose: 15000 });
          break;
        case 'loading':
          toast.loading(message);
          break;
        default:
          toast(message, { autoClose: 15000 });
      }
    } catch { }
  };
}

export default MessageProvider;
